import React from "react";
import "./PageFormProgress.scss";
import ProgressStep from "./ProgressStep/ProgressStep";

/**
 * Step shape consumed by the progress UI. A structural subset of
 * `FormWizardStep` (no `form`/`depsMap`), so wizard steps are assignable here.
 * `completed`/`failed` are optional to match `FormWizardStep`.
 */
export type StepProps = {
  id: string;
  name: string;
  failed?: boolean;
  completed?: boolean;
};

export type PageFormProgressProps = {
  steps: StepProps[];
  activeStepIndex: number;
};

const PageFormProgress: React.FC<PageFormProgressProps> = ({
  steps,
  activeStepIndex,
}) => {
  return (
    <div className={"progress-container"} data-testid={"page-form-progress"}>
      {steps?.map((step, index) => (
        <ProgressStep
          key={step.id}
          index={index}
          name={step.name}
          active={index === activeStepIndex}
          completed={step.completed}
          failed={step.failed}
          isLast={index === steps?.length - 1}
        />
      ))}
    </div>
  );
};

export default PageFormProgress;
